export enum CreateTransactionTypes {
  LEASE,
  LEASE_RENEWAL,
  RENT_REVIEW,
  OCCUPATIONAL_SALE,
  INVESTMENT_SALE,
}

export enum CreateTransactionSteps {
  SELECT_TYPE = 'SELECT_TYPE',
  ADDRESS_LOOKUP = 'ADDRESS_LOOKUP',
  ADDRESS_CONFIRM = 'ADDRESS_CONFIRM',
  PROPERTIES_LOOKUP = 'PROPERTIES_LOOKUP',
  SET_DETAILS = 'SET_DETAILS',
}
